import React from 'react';

import { MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const StyledSelect = styled(Select)`
  fieldset {
    border: 1px solid #eaeaea;
  }
  p {
    font-size: 14px;
  }
`;

// using useStyles also as styled-components padding override was not working at one of two imported places
const useStyles = makeStyles({
  select: {
    padding: '0.25rem 3rem 0.25rem 0.5rem',
  },
  iconOutlined: {
    color: theme.palette.icons.grey2,
  },
});

const Dropdown = ({
  allOptions,
  optionFormatter,
  selectedValue,
  onChange,
  disabled = false,
  fullWidth = false,
  disableListPortal = false,
}) => {
  const classes = useStyles();
  return (
    <StyledSelect
      disabled={disabled}
      fullWidth={fullWidth}
      variant="outlined"
      value={selectedValue}
      classes={classes}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        variant: 'selectedMenu',
        style: {
          maxHeight: '350px',
        },
        disablePortal: disableListPortal,
      }}
      onChange={({ target }) => {
        onChange(target.value);
      }}
    >
      {allOptions.map((value, index) => (
        <MenuItem key={`recurrence-period-${index}`} value={value}>
          <StyledTypography style={{ whiteSpace: 'normal' }} variant="body1">
            {optionFormatter(value)}
          </StyledTypography>
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default Dropdown;
